export default __webpack_public_path__ + "static/media/selectedPool.4729e5ff.svg";